module.exports = __webpack_public_path__ + "img/BE.2f762fbb.svg";